const bulkProcess = {
  title: 'Bulk Process',
  bulk: 'Bulk',
  generate: 'Generate',
  reItem: 'Re-Item',
  'generate-description': 'Generate Description',
  'generate-item': 'Generate Item',
  'set-normal': 'Set Normal',
  'generate-resume': 'Generate Resume',
  'generate-critical-case': 'Generate Critical Case',
  column: {
    remarks: 'Remarks'
  },
  process: 'Process',
  bulkUpdateKitVersion: 'Bulk Update Kit Version',
  updateKitVersion: 'Bulk Update Kit Version',
  modalBulkProcess: {
    selectExaminationItem: 'Select Examination Item',
    selectResultLibrary: 'Select Result & Conclusion Library',
    examinationItem: 'Examination Item',
    resultConclution: 'Result & Conclusion Library',
    examinationItem: 'Examination Item',
    libraryName: 'Library Name',
    category: 'Category',
    examination: 'Examination',
    selectResult: 'Select Result & Conclusion Library',
    code: 'Item Code',
    kitVersion: 'Kit Version',
    selectKitVersion: 'Select Kit Version'
  },
  'kit-version': 'Update Kit Version',
  kitVersion: {
    kitVersion: 'Kit Version',
    unit: 'Unit',
    updateKitVersion: 'Update Kit Version',
    listUpdate: 'List Update Process',
    selectKitVersion: 'Select Kit Version',
    totalSelected: 'Total Selected'
  }
}

export default bulkProcess
